/**
 * Centralizes every order-scoped URL, so "is this a dropoff-tracking link"
 * (see `DropoffTrackingContext`) is decided in exactly one place — the `d/`
 * prefix — instead of being reconstructed with a ternary at every
 * `navigate(...)` call site. `trackCode` is the opaque URL identifier from
 * the legacy router (`/:trackCode`, `/details/:trackCode`), not the real
 * internal order id — see `useOrderSummary`. Home keeps the legacy's exact
 * bare-trackCode URL (`/:trackCode` / `/d/:trackCode`); every other page is
 * new and nests under `/details/:trackCode/...` (and its `/d/` twin),
 * extending rather than replacing the legacy scheme.
 */
const home = (trackCode: string, isDropoffTracking: boolean) => `/${isDropoffTracking ? "d/" : ""}${trackCode}`;
const detailsBase = (trackCode: string, isDropoffTracking: boolean) =>
  `/${isDropoffTracking ? "d/" : ""}details/${trackCode}`;

export const orderPaths = {
  home,
  details: detailsBase,
  pickup: (trackCode: string, isDropoffTracking: boolean) => `${detailsBase(trackCode, isDropoffTracking)}/pickup`,
  dropoff: (trackCode: string, stopId: string, isDropoffTracking: boolean) =>
    `${detailsBase(trackCode, isDropoffTracking)}/dropoff/${stopId}`,
  customerCustomFields: (trackCode: string, isDropoffTracking: boolean) =>
    `${detailsBase(trackCode, isDropoffTracking)}/customer/custom-fields`,
  driverCustomFields: (trackCode: string, isDropoffTracking: boolean) =>
    `${detailsBase(trackCode, isDropoffTracking)}/driver/custom-fields`,
  serviceDetails: (trackCode: string, isDropoffTracking: boolean) =>
    `${detailsBase(trackCode, isDropoffTracking)}/service/details`,
  vehicleDetails: (trackCode: string, isDropoffTracking: boolean) =>
    `${detailsBase(trackCode, isDropoffTracking)}/vehicle/details`,
  events: (trackCode: string, isDropoffTracking: boolean) => `${detailsBase(trackCode, isDropoffTracking)}/events`,
};
